export const reloadApp = () => {
  localStorage.setItem('reloaded', 'true');
  window.location.reload();
};
